import { Button } from '@spaceshipapp/cambridge';
import styled from 'styled-components';

export const FormButton = styled(Button)`
  display: relative;
  width: 100%;
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 1rem;
`;
